import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import { DateFormatEnum } from '@enum/date-format.enum';
import { CredentialInterface } from '@interface/credential/credential.interface';

import { ConsumerApiKey } from './api-key/api-key';
import { CredentialsUser } from './credentials-user/credentials-user';
import { DeleteCredential } from './delete-credential/delete-credential';

export const credentialColumns = (
  isTablet: boolean,
  isMobile: boolean,
  shouldShowDeleteButton: boolean,
): ColumnsType<CredentialInterface> =>
  (
    [
      {
        title: 'Api Key',
        dataIndex: 'apiKey',
        key: 'apiKey',
        ellipsis: true,
        render: (apiKey) => <ConsumerApiKey apiKey={apiKey} />,
      },
      // !isMobile && {
      //   title: 'Role',
      //   dataIndex: 'role',
      //   key: 'role',
      //   width: 80,
      //   render: (role) => <RoleTag style={{ marginLeft: -8 }}>{role.toLowerCase()}</RoleTag>,
      // },
      // {
      //   title: 'Consumer',
      //   dataIndex: 'consumer',
      //   key: 'consumer',
      //   render: (id) => <CredentialsConsumer id={id} />,
      // },
      {
        title: 'Created Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: isTablet || isMobile ? 96 : 184,
        render: (date) => dayjs(date).format(isTablet || isMobile ? DateFormatEnum.FullShort : DateFormatEnum.Full),
        sorter: shouldShowDeleteButton ? (a, b) => +new Date(a.createdAt) - +new Date(b.createdAt) : undefined,
      },
      {
        title: 'Created By',
        dataIndex: 'user',
        key: 'user',
        width: 108,
        ellipsis: true,
        render: (user) => <CredentialsUser user={user} />,
      },
      shouldShowDeleteButton && {
        title: '',
        dataIndex: 'id',
        key: 'actions',
        width: isTablet || isMobile ? 72 : 120,
        render: (id) => <DeleteCredential id={id} isTablet={isTablet || isMobile} />,
      },
    ] as ColumnsType<CredentialInterface>
  ).filter(Boolean);
